export const UPGRADE_FIRST_AB_TEST_NAME = 'Mimika|Upgrade (1st)';
export enum UpgradeFirstAbTestCaseName {
  DEFAULT = 'A default',
  NEW = 'Mimika|Upgrade (1st)',
}

export const COOKIES_AB_TEST_NAME = 'Mimika| Cookie';
export enum CookiesAbTestCaseName {
  DEFAULT = 'A default',
  NEW = 'B Cookie',
}

export const WELCOME_LOADER_TEST_NAME_V2 = 'DEV-863 a/b first screen loader v2';
export enum WelcomeLoaderTestV2CaseName {
  DEFAULT = 'A default',
  SHOW = 'B first screen loader',
}

export const VIDEO_REVIEWS_TEST_NAME = 'video feedback';
export enum VideoReviewsTestCaseName {
  HIDE = 'A default',
  SHOW = 'B video feedback',
}

export const SCANNER_TEST_NAME = 'DEV-973 Scanner screens';

export const SIMPLE_PAYWALL_TEST_NAME = 'Simple paywall - dev 1170';

export const CHEEP_CHALLENGE_TEST_NAME = 'cheap intro offer';
export enum CheepChallengeTestCaseName {
  DEFAULT = 'A Default',
  ONBOARDING_BEGIN = 'B change first screen',
  ONBOARDING_MIDDLE = 'C middle offer',
}

export const ACADEMIA_UPSELL_TEST_NAME = 'Academy Upsale';
export const BEFORE_AFTER_PAYWALL_TEST_NAME = 'Mimika| Lips paywall';
export const HIDE_PAYPAL_TEST_NAME = 'Without PayPal';
export const SHOPPER_TEST_NAME = 'Bag US/WW';
export const OLD_CARD_TEST_NAME = 'DEV-1671| Mimika - Old Card';
export const MEWING_BUNDLE_TEST_NAME = 'mewing bundle';
export const BUNDLE_VARIANT_DIFFERENT_PLANS = 'different price';
export const MEWING_PT_BUNDLE_VARIANT_DIFFERENT_PLANS = 'mewingPT bundle';
export const MEWING_TT_BUNDLE_VARIANT_DIFFERENT_PLANS = 'mewingTikTok bundle';
export const MEWING_WOMEN_VARIANT_DIFFERENT_PLANS = 'mewingwomen bundle';
export const V21_TT_BUNDLE_DIFFERENT_PLANS = 'Bundle variant21bundleTT';
export const V21_PT_BUNDLE_DIFFERENT_PLANS = 'Bundle variant21bundlePT';
export const MAXI_WELCOME_SCREEN = 'MAXI|First Screen';
export const ASYM_WOMEN_SCREEN_TEST_NAME = 'Women|FScreen';

export const ABC_ASYM_TEST_NAME = 'ABC ASYM';
export enum AbcAsymTestCaseName {
  DEFAULT = 'A default',
  QUESTION = 'B question',
  HEAD = 'C head',
}
